import React, { FC, ReactElement } from 'react';
import { withStyles } from '@mui/styles';
// Components
import PinPanelComponent from './pinPanelComponent';
// Resources
import { PinProps } from './mapTypes';
import SvgIcon from '../icons/SvgIcon';
// Style
import styles from './pin-style';
import { IconAxel } from '../../resources/images';

const PickUpPinComponent: FC<PinProps> = ({ lat, lng, classes, drawed, ...rest }): ReactElement => {
    return (
        <div id="from">
            <SvgIcon icon={IconAxel.PickupPin} className={classes.pinPos} size="inherit" />
            <PinPanelComponent mode="from" {...rest} classes={classes} drawed={drawed} />
        </div>
    );
};

export default withStyles(styles)(PickUpPinComponent);
